import { z } from 'zod'

/**
 * Why matching couldn't hand an event over to a HoneyBook booking on its own
 * (docs/honeybook.plan.md, 5.2). Mirrors the `HoneyBookReviewReason` enum in the
 * Prisma schema (`check:enums`).
 */
export const HONEYBOOK_REVIEW_REASONS = ['date_differs', 'email_ambiguous', 'clef_unsure'] as const

export const honeybookReviewReasonSchema = z.enum(HONEYBOOK_REVIEW_REASONS)

export type HoneyBookReviewReason = z.infer<typeof honeybookReviewReasonSchema>
